export const HIGHCHARTS_THEME = {
  colors: ['#2563eb', '#10b981', '#8b5cf6', '#f59e0b', '#ef4444', '#06b6d4', '#ec4899'],
  chart: {
    backgroundColor: 'transparent',
    style: { fontFamily: 'ui-sans-serif, system-ui, -apple-system, sans-serif' },
  },
  title:    { style: { display: 'none' } },
  subtitle: { style: { display: 'none' } },
  xAxis: {
    gridLineColor: '#f3f4f6',
    lineColor:     '#e5e7eb',
    tickColor:     '#e5e7eb',
    labels: { style: { color: '#6b7280', fontSize: '11px' } },
  },
  yAxis: {
    gridLineColor: '#f3f4f6',
    labels: { style: { color: '#6b7280', fontSize: '11px' } },
    title: { text: null },
  },
  legend: {
    itemStyle: { color: '#374151', fontWeight: '500', fontSize: '12px' },
    itemHoverStyle: { color: '#111827' },
  },
  tooltip: {
    backgroundColor: '#1f2937',
    borderColor:     '#374151',
    borderRadius:    8,
    style: { color: '#f9fafb', fontSize: '12px' },
    shadow: false,
  },
  plotOptions: {
    series: { animation: { duration: 300 } },
  },
  credits: { enabled: false },
}
